import relatorioApi from 'api/Assessor/relatorios';
import { ErrorAPI } from 'api/Associado/methods';
import { AxiosError } from 'axios';
import AssembleiaAlterarSituacaoModal from 'components/AssembleiaAlterarSituacaoModal/AssembleiaAlterarSituacaoModal';
import AssembleiaEditModal, { IAssembleiaEditModal } from 'components/AssembleiaEditModal/AssembleiaEditModal';
import CadastroPautaModal, { ICadastroPautaModalProps } from 'components/CadastroPautaModal/CadastroPautaModal';
import ConfirmModal, { IConfirmModalGenericProps } from 'components/ConfirmModal/ConfirmModal';
import LayoutContext from 'components/Layout/LayoutContext';
import LoadingScreen from 'components/LoadingScreen/LoadingScreen';
import SeletorAssessorContasParaVotoModal, { ISeletorContasParaVotoGenericProps } from 'components/SeletorAssessorContasParaVotoModal/SeletorAssessorContasParaVotoModal';
import { ITopBarMenuItem } from 'components/TopBar/TopBarMenuItem';
import UnauthorizedScreen from 'components/UnauthorizedScreen/UnauthorizedScreen';
import { AssembleiaStatus, AssembleiaStatusDescription } from 'enuns/AssembleiaStatus';
import { DateFormats } from 'enuns/DateTypes';
import { TopBarMenuAcessoRapido } from 'enuns/TopBarMenuAcessoRapido';
import { MainAssessorRoutePath, VotoCanalVozPath } from 'library/Routes';
import { AssembleiaContaAssessor } from 'models/AssembleiaContaAssessor';
import PresencasResponse from 'models/PresencasResponse';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { bindActionCreators, Dispatch } from 'redux';
import { assembleiaAssessorAtualizarConvocados, assembleiaAssessorBloquearConvocacao, assembleiaAssessorForceLoadPautas, assembleiasAssessorActionsAtualizarPresencas, assembleiasAssessorActionsDeleteCurrentEvent, assembleiasAssessorActionsLoadContas, assembleiasAssessorActionsLoadPautas, assembleiasAssessorDeletarAssembleia, assembleiasAssessorLoadEvento } from 'store/modules/AssembleiasAssessorActions';
import { IAssembleiasAssessorEvent, IAssembleiasAssessorReducer } from 'store/modules/AssembleiasAssessorReducer';
import { modalsActionsOpen } from 'store/modules/ModalsActions';
import { wsAssembleiasActionsSendMessage } from 'store/modules/WSAssembleiasActions';
import { IReducer } from 'store/Reducer';
import { wsStartStop } from 'utils/AssembleiaUtils';
import AxiosErrorHandler from 'utils/AxiosErrorHandler';
import { getFormatedDateTime } from 'utils/DateUtils';
import DownloadTrigger from 'utils/DownloadTrigger';
import ErrorHandler from 'utils/ErrorHandler';
import { getUniqueKey } from 'utils/KeyUtils';
import { getAcessoRapido } from 'utils/TopBarMenuUtils';
import Context, { AssembleiaAssessorActionsDownloadDocument } from './Context';
import DocumentosModal, { EditarDocumentosModalProps } from './DocumentosModal';
import Evento from './Evento';
interface RouteParams {
  id: string;
}

const mapStateToProps = (state: IReducer) => {
  return {
    assembleiasAssessor: state.assembleiasAssessor,
    loadingEvent: state.assembleiasAssessor.loadingEvento,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      /* assembleiaAssociadoActionsDownloadDocument, */
      assembleiasAssessorActionsLoadContas,
    },
    dispatch
  );

interface Props {
  loadingEvent: boolean;
  assembleiasAssessor: IAssembleiasAssessorReducer | null;
  assembleiaAssessorActionsDownloadDocument: AssembleiaAssessorActionsDownloadDocument;
  assembleiasAssessorActionsLoadContas: (assembleiaId: number, cpfCnpj: string, callbackSuccess?: (contas: AssembleiaContaAssessor[]) => void, callbackError?: (error: AxiosError<ErrorAPI>) => void) => void;
}

function AssembleiaAssessor({
  loadingEvent,
  assembleiasAssessor,
  assembleiaAssessorActionsDownloadDocument,
}: Props) {
  const {t} = useTranslation();
  const [sentWS, setSentWS] = useState(true);
  const { id } = useParams<RouteParams>();
  const location = useLocation();
  const { usuario } = useSelector((state: IReducer) => state.auth);
  const { opened: wsOpened } = useSelector((state: IReducer) => state.wsAssembleias);
  const { setPageMenuItems, startLoading, finishLoading } = useContext(LayoutContext);
  const [initialized, setInitialized] = useState<boolean>();
  const [atualizandoPresencas, setAtualizarPresencas] = useState<boolean>(false);
  const [atualizacoesPresenca, setAtualizacoesPresenca] = useState<number>(0);
  const [deletandoAssembleia, setDeletandoAssembleia] = useState<boolean>(false);
  const routeHistory = useHistory();
  const [convocando, setConvocando] = useState<boolean>(false);
  const [bloqueando, setBloqueando] = useState<boolean>(false);
  const [presencas, setPresencas] = useState<PresencasResponse>();
  const [forcedLoadPautas, setForcedLoadPautas] = useState<boolean>();
  const dispatch = useDispatch();
  const wsAssembleias = useSelector((state: IReducer) => {
    return state.wsAssembleias;
  })

  const hasPermission = useCallback((): boolean => {
    if (usuario) {
      return usuario.perfil.assessorRoute.assembleias.ver;
    }
    return false;
  }, [usuario])

  const evento = useMemo<IAssembleiasAssessorEvent | null>(() => {
    return assembleiasAssessor && assembleiasAssessor.evento;
  }, [assembleiasAssessor])

  const loadingEvento = useMemo<boolean>(() => {
    return !!assembleiasAssessor && !!assembleiasAssessor.loadingEvento;
  }, [assembleiasAssessor])

  const sendWSMessage = useCallback(() => {
    const trySendMessage = () => {
      dispatch(
        wsAssembleiasActionsSendMessage(
          {
            "id": id,
            "status": null,
            "isChatAtivo": null,
            "presentes": null,
            "pautas": []
          },
          undefined,
          () => setTimeout(trySendMessage, 2000)
        )
      );
    }
    trySendMessage();
  }, [dispatch, id]);

  useEffect(() => {
    if (!sentWS && wsAssembleias.opened && assembleiasAssessor && assembleiasAssessor.evento && assembleiasAssessor.evento.id === Number(id)) {
      setSentWS(true);
      sendWSMessage();
    }
  }, [setSentWS, sendWSMessage, sentWS, wsAssembleias, wsAssembleias.opened, assembleiasAssessor, id])

  useEffect(() => {
    if (!initialized) {
      if (
        !deletandoAssembleia &&
        (
          (assembleiasAssessor && assembleiasAssessor.evento?.id !== parseInt(id)) || 
          assembleiasAssessor?.evento?.needLoadAssembleia
        )
      ) {
        setInitialized(true);
        dispatch(
          assembleiasAssessorLoadEvento(
            parseInt(id),
            () => setConvocando(false),
            error => {
              setConvocando(false);
              ErrorHandler(error.response!.data);
              window.setTimeout(() => {
                window.location.href = '/assembleiadefundos/assessor';
              }, 2000);
            }
          )
        );
      } else {
        if (!assembleiasAssessor?.evento?.needLoadPautas && !forcedLoadPautas) {
          setForcedLoadPautas(true);
          dispatch(assembleiaAssessorForceLoadPautas())
        }
      }
    }
  }, [dispatch, assembleiasAssessor, forcedLoadPautas, initialized, setInitialized, id, deletandoAssembleia, setForcedLoadPautas]);

  useEffect(() => {
    if (initialized && assembleiasAssessor?.evento?.id === parseInt(id) && assembleiasAssessor?.evento?.needLoadAssembleia) {
      setInitialized(false);
    }
  }, [dispatch, initialized, id, assembleiasAssessor, setInitialized])

  useEffect(() => {
    return () => {
      setInitialized(false);
      dispatch(assembleiasAssessorActionsDeleteCurrentEvent());
    }
  }, [setInitialized, dispatch, id])

  useEffect(() => {
    if (usuario) {
      wsStartStop(
        usuario,
        Number(id),
        dispatch,
        wsOpened
      )
    }
  }, [usuario, location, id, dispatch, wsOpened])

  const isButtonCadastroPautaDisabled = useMemo<boolean>(() => {
    if (evento?.status === AssembleiaStatus.Encerrado) {
      return true;
    }

    if (evento?.status === AssembleiaStatus.Pos) {
      return true;
    }

    return !usuario?.perfil.assessorRoute.assembleias.cadastroPauta.cadastrar
  }, [evento, usuario]);
  
  const openCadastroPautaModal = useCallback(() => {
    if (!evento) return;
    const modalKey: string = getUniqueKey();
    dispatch(
      modalsActionsOpen(
        CadastroPautaModal,
        {
          genericProps: {
            key: modalKey,
            idEvento: evento.id,
            status: evento.status,
            produtosAssembleia: evento.produtos,
          } as ICadastroPautaModalProps,
        },
        modalKey
      )
    );
  }, [dispatch, evento]);

  // const openCadastroPautaModal = useCallback(() => {
  //   const modalKey: string = getUniqueKey();
  //   modalsActionsOpen(
  //     CadastroPautaModal,
  //     {
  //       genericProps: {
  //         key: modalKey,
  //         idEvento: assembleia?.id,
  //         status: assembleia?.status,
  //         produtosAssembleia: assembleia!.produtos,
  //       } as ICadastroPautaModalProps,
  //     },
  //     modalKey
  //   );
  // }, [modalsActionsOpen, assembleia]);

  /*const contadorContasDisabled = useMemo((): boolean => {
    if (!evento || loadingEvento) return true;
    if (evento.status === AssembleiaStatus.Live) {
      return false;
    }
    return true;
  }, [evento, loadingEvento]);*/

  const openConfiguracaoVotos = useCallback(() => {
    if (!!assembleiasAssessor && usuario) {
      const modalKey: string = getUniqueKey();
      dispatch(
        modalsActionsOpen(
          SeletorAssessorContasParaVotoModal,
          {
            genericProps: {
              assembleia: assembleiasAssessor!,
              cpfCnpj: usuario!.cpfCnpj,
              key: modalKey,
            } as ISeletorContasParaVotoGenericProps,
          },
          modalKey
        )
      );
    }
  }, [dispatch, usuario, assembleiasAssessor]);

  const openNewTabVotacao = useCallback(() => {
    const url = VotoCanalVozPath.replace(':idAssembleia', id);
    const win = window.open(url, '_blank');
    win!.focus();
  }, [id]);
  
  const excluirEvento = useCallback(() => {
    setDeletandoAssembleia(true);
    dispatch(
      assembleiasAssessorDeletarAssembleia(
        assembleiasAssessor!.evento!.id,
        () => {
          routeHistory.push(MainAssessorRoutePath);
        },
        error => {
          setDeletandoAssembleia(false);
          AxiosErrorHandler(error);
        }
      )
    );
  }, [assembleiasAssessor, dispatch, setDeletandoAssembleia, routeHistory]);
  
  const openExcluirEventoModal = useCallback(() => {
    const modalKey: string = getUniqueKey();
    dispatch(
      modalsActionsOpen(
        ConfirmModal,
        {
          genericProps: {
            contentText: (
              <span
                dangerouslySetInnerHTML={{
                  __html: t('AssembleiaAssessorRoute.deletarAssembleiaConfirmModal.text', {
                    assembleia: '<strong>' + assembleiasAssessor!.evento!.nome + '</strong>',
                  }),
                }}
              />
            ),
            title: t('AssembleiaAssessorRoute.deletarAssembleiaConfirmModal.title'),
            confirmLabel: t('AssembleiaAssessorRoute.deletarAssembleiaConfirmModal.confirmar'),
            key: modalKey,
            confirmCallback: excluirEvento,
          } as IConfirmModalGenericProps,
        },
        modalKey
      )
    )
  }, [t, dispatch, assembleiasAssessor, excluirEvento]);

  const editarAssembleia = useCallback(() => {
    const modalKey: string = getUniqueKey();
    dispatch(
      modalsActionsOpen(
        AssembleiaEditModal,
        {
          genericProps: {
            key: modalKey,
            assembleia: assembleiasAssessor!.evento
          }
        } as IAssembleiaEditModal,
        modalKey
      )
    )
  }, [dispatch, assembleiasAssessor])
 // eslint-disable-next-line
  const disabledExcluirEvento = useMemo<boolean>(() => {
    return loadingEvento || deletandoAssembleia || assembleiasAssessor?.evento?.status !== AssembleiaStatus.NaoDisponivel;
  }, [loadingEvento, deletandoAssembleia, assembleiasAssessor])

  const alterarSituacao = useCallback(() => {
    if (!evento) return;
    const modalKey: string = getUniqueKey();
    dispatch(
      modalsActionsOpen(
        AssembleiaAlterarSituacaoModal,
        {
          genericProps: {
            currentEvent: evento,
            key: modalKey,
          },
        },
        modalKey
      )
    );
  }, [dispatch, evento]);

  const convocarEvento = useCallback(async () => {
    if (!evento) return;
    if (deletandoAssembleia) return;
    setConvocando(true);
    startLoading('Aguarde, convocando cotistas.', true);
    dispatch(
      assembleiaAssessorAtualizarConvocados(
        evento.id,
        () => {
          dispatch(
            assembleiasAssessorLoadEvento(
              evento.id,
              () => {
                setConvocando(false);
                startLoading('', false);
              },
              error => {
                setConvocando(false);
                startLoading('', false);
                ErrorHandler(error.response!.data);
              }
            )
          );
        },
        error => {
          finishLoading();
          setConvocando(false);
          ErrorHandler(error);
        }
      )
    )
  }, [evento, dispatch, startLoading, finishLoading, setConvocando, deletandoAssembleia]);

  const bloquearEvento = useCallback(async () => {
    if (!evento) return;
    setBloqueando(true);
    startLoading('Aguarde, evento sendo bloqueado.', true);
    // const { fail, response } = await api.evento.bloquear(evento.id);
    dispatch(
      assembleiaAssessorBloquearConvocacao(
        evento.id,
        () => {
          dispatch(
            assembleiasAssessorLoadEvento(
              evento.id,
              () => {
                setBloqueando(false);
                startLoading('', false);
              },
              error => {
                setBloqueando(false);
                startLoading('', false);
                ErrorHandler(error.response!.data);
              }
            )
          );
        },
        error => {
          finishLoading();
          setBloqueando(false);
          ErrorHandler(error);
        }
      )
    )
  }, [evento, dispatch, startLoading, finishLoading]);

  const atualizarPresencas = useCallback(async () => {
    if (!evento?.id || evento.id !== parseInt(id)) return;
    setAtualizacoesPresenca(atualizacoesPresenca + 1);
    setAtualizarPresencas(true);
    dispatch(
      assembleiasAssessorActionsAtualizarPresencas(
        evento.id,
        data => {
          setPresencas(data);
          setAtualizarPresencas(false);
        },
        fail => {
          ErrorHandler(fail);
          setAtualizarPresencas(false);
        }
      )
    );
  }, [dispatch, evento, setAtualizarPresencas, id, setAtualizacoesPresenca, atualizacoesPresenca]);

  useEffect(() => {
    if (
      evento &&
      usuario?.cpfCnpj &&
      usuario!.perfil.assessorRoute.assembleias.pautas.ver &&
      evento.needLoadPautas
    ) {
      dispatch(
        assembleiasAssessorActionsLoadPautas(evento.id, usuario?.cpfCnpj)
      )
    }
  }, [evento, usuario, dispatch]);

  const openDocumentos = useCallback(() => {
    if (!evento) return;
    const modalKey: string = getUniqueKey();
    dispatch(
      modalsActionsOpen(
        DocumentosModal,
        {
          genericProps: {
            key: modalKey,
          },
        } as EditarDocumentosModalProps,
        modalKey
      )
    );
  }, [dispatch, evento]);

  const baixarRelatorioVotos = useCallback(async () => {
    if (!evento) return;
    const { fail, data } = await relatorioApi.relatorioVotos(evento.id);
    if (fail) {
      ErrorHandler(fail);
    }
    if (data) {
      const fileDate = getFormatedDateTime(Date.now(), DateFormats.ISOFile);
      DownloadTrigger(`Relatorio-Votacao_${fileDate}_Evento-${evento.id}.xls`, data);
    }
  }, [evento]);

  const baixarRelatorioFinal = useCallback(async () => {
    if (!evento) return;
    const { fail, data } = await relatorioApi.relatorioFinal(evento.id);
    if (fail) {
      ErrorHandler(fail);
    }
    if (data) {
      const fileDate = getFormatedDateTime(Date.now(), DateFormats.ISOFile);
      DownloadTrigger(`Relatorio-Evento_${fileDate}_Evento-${evento.id}.xls`, data);
    }
  }, [evento]);

  const habilitarBotaoStatusAssembleia = useMemo(() => {
    if (evento?.statusDesc === AssembleiaStatusDescription.ASSEMBLEIA) {
      return false;
    }
    return true;
  }, [evento]);

  const habilitarBotaoStatusEncerrada = useMemo(() => {
    if (evento?.status === AssembleiaStatus.Encerrado) {
      return false;
    }
    return true;
  }, [evento]);

  const subMenu = useMemo<ITopBarMenuItem[]>(() => {
    if (usuario) {
      const menus: ITopBarMenuItem[] = getAcessoRapido(t, usuario.perfil, TopBarMenuAcessoRapido.Assembleias, id);

      menus.push({
        label: t(`SubMenus.editarAssembleia`),
        disabled: loadingEvento,
        onClick: editarAssembleia
      });

      if (usuario.perfil.assessorRoute.assembleias.documentos.editar) {
        menus.push({
          label: t(`SubMenus.documentos`),
          onClick: openDocumentos,
          disabled: loadingEvento
        });
      }

      menus.push({
        label: t(`SubMenus.cadastrarPauta`),
        disabled: loadingEvento || isButtonCadastroPautaDisabled,
        onClick: openCadastroPautaModal,
      });

      menus.push({
        label: t(`SubMenus.confirmarPresenca`),
        onClick: openConfiguracaoVotos,
        disabled: loadingEvento || habilitarBotaoStatusAssembleia
      });

      menus.push({
        label: t(`SubMenus.votacaoCanalVoz`),
        onClick: openNewTabVotacao,
        disabled: loadingEvento || habilitarBotaoStatusAssembleia
      });

      menus.push({
        label: t(`SubMenus.relatorioVoto`),
        onClick: baixarRelatorioVotos,
        disabled: loadingEvento || (habilitarBotaoStatusAssembleia && habilitarBotaoStatusEncerrada)
      });

      menus.push({
        label: t(`SubMenus.resultadoFinal`),
        onClick: baixarRelatorioFinal,
        disabled: loadingEvento || habilitarBotaoStatusEncerrada
      });

      if (usuario!.perfil.assessorRoute.assembleias.alterarSituacao) {
        menus.push({
          label: t(`SubMenus.excluirEvento`),
          onClick: openExcluirEventoModal,
          disabled: false,
        });
      }

      return menus;
    }

    return [];

  }, [t, editarAssembleia, usuario, id, openDocumentos, loadingEvento, openExcluirEventoModal, isButtonCadastroPautaDisabled, openCadastroPautaModal, openConfiguracaoVotos, habilitarBotaoStatusAssembleia, habilitarBotaoStatusEncerrada, baixarRelatorioVotos, baixarRelatorioFinal, openNewTabVotacao])

  useEffect(() => {
    if (atualizacoesPresenca === 0 && !atualizandoPresencas) {
      atualizarPresencas();
    }
  }, [atualizarPresencas, atualizacoesPresenca, atualizandoPresencas])

  useEffect(() => {
    setPageMenuItems(subMenu);
    return () => setPageMenuItems();
  }, [subMenu, setPageMenuItems]);

  if (!usuario || (!assembleiasAssessor!.evento && loadingEvent)) {
    return (
      <LoadingScreen />
    );
  }

  if (!hasPermission()) {
    return <UnauthorizedScreen />;
  }

  return assembleiasAssessor?.evento?.id === Number(id) ? (
    <Context.Provider
      value={{
        currentEvent: assembleiasAssessor,
        assembleiaAssessorActionsDownloadDocument,
        evento: assembleiasAssessor?.evento,
        loadingEvento: assembleiasAssessor?.loadingEvento,
        loadingPautas: assembleiasAssessor?.loadingPautas,
        alterarSituacao,
        convocarEvento,
        convocando,
        bloquearEvento,
        bloqueando,
        presencas: presencas || null,
        atualizarPresencas,
        atualizandoPresencas,
      }}
    >
      <Evento />
    </Context.Provider>
  ) : null;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssembleiaAssessor);
